import { render, staticRenderFns } from "./TgMenu.vue?vue&type=template&id=faf63882"
import script from "./TgMenu.vue?vue&type=script&lang=js"
export * from "./TgMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports